import React, { Component } from 'react'

class FooterComponent extends Component {
    render() {
        return (
            <footer className="footer">
                <span className="text-muted">All Rights Reserved 2022 @mani</span>
            </footer>
        )
    }
}

export default FooterComponent